import { UploadDocumentType } from './types';

export const normalizeDocumentsList = (
  documents: UploadDocumentType[]
): UploadDocumentType[] =>
  documents.sort(
    (d1, d2) => Number(!!d2.RequiredDocument) - Number(!!d1.RequiredDocument)
  );
